import jdbc from "../assets/Java_jdbc.png";
import csharp_gui from "../assets/csharp_gui.png";

const OOPCardData = [
  {
    imgsrc: jdbc,
    title: "Java -- Application using JDBC and MySQL",
    text: "The application applies Java Swing and MySQL in which users can register as a player and record the game score. The database allows the user to create and amend the records.",
    //   view: "",
    github: "https://github.com/chunyim/Java--JDBC-applications",
  },
  {
    imgsrc: csharp_gui,
    title: "C# -- Simple GUI with Multicast Delegate",
    text: "It is an notification management system allowing (1) clients to subscribe and subscribe the notification, and (2) admins to publish notification.",
    //   view: "",
    github: "https://github.com/chunyim/Csharp--GUI-multicast-delegate",
  },
];

export default OOPCardData;
